export default "__VITE_ASSET__VvZgnaYi__"